<div class="carrusel">
  @for (product of data(); track $index) {
  <article class="carrusel-item relative">
    <i class="btn-favorite pi absolute"
      [ngClass]="{'pi-heart-fill btn-favorite--fill': product.favorite, 'pi-heart': !product.favorite, 'no-selected': totalFavorites >= 3}"
      (click)="addFavorite(btn, product)" #btn></i>
    <div class="carrusel-item__img-container">
      <img class="carrusel-item__img" [src]="product.imagenes" [alt]="product.nombre_comercial"
        (error)="onLoadNoImage(img)" loading="lazy" #img>
    </div>
    <div class="carrusel-item__texts">
      <div class="carrusel-item__description">
        <p class="carrusel-item__brand">{{product.marca}}</p>
        <p class="carrusel-item__comercial-name">{{onLoadComercialName(product)}}</p>
        <p class="carrusel-item__color">{{product.color}}</p>
      </div>
      <div class="carrusel-item__prices">
        <p class="carrusel-item__downpayment-label">Enganche desde:</p>
        <p class="carrusel-item__downpayment">{{product.enganche | currency}}</p>
      </div>
    </div>
  </article>
  }
</div>
